import React from 'react';
import { useParams } from 'react-router-dom';
import { useNotificationById } from '../lib/usefetchNotificationById'; 
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './notifications-details.css';

const NotificationDetails = () => {
  const { notificationId } = useParams(); 
  const { data, isLoading, isError } = useNotificationById(notificationId);


  const notification = data?.data || null; 

  return (
    <div className='notification-details'>
      <h1>Notification Details</h1>

    
      {isLoading && (
        <div className='loading-skeleton'>
          <Skeleton height={30} width={200} />
          <Skeleton height={20} width={150} />
          <Skeleton height={20} width={300} />
          <Skeleton height={20} width={250} />
        </div>
      )}

      {/* Error state */}
      {isError && (
        <div className='error-message'>
          <p>Failed to load notification. Please try again later.</p>
        </div>
      )}

      {/* Notification content */}
      {!isLoading && !isError && notification ? (
        <div className='notification-card'>
          <p><strong>Message:</strong> {notification.message}</p>
          <p><strong>User Type:</strong> {notification.userType}</p>
          <p><strong>Action:</strong> {notification.params?.action || 'N/A'}</p>
          <p><strong>Endpoint:</strong> {notification.params?.endpoint || 'N/A'}</p>
          <p><strong>Date:</strong> {new Date(notification.createdAt).toLocaleString()}</p>
        </div>
      ) : !isLoading && !isError && !notification ? (
        <div className='no-notification'>
          <p>No notification found.</p>
        </div>
      ) : null}
    </div>
  );
};

export default NotificationDetails;
